import React, { Component } from "react";
import "./../pedido-atacado.css";
import { Badge } from "react-bootstrap";
import AppContext from "../../appContext";
import Input from "../../components/inputs/input";
import Select from "../../components/selects/select";
import CnpjUtils from "../../shared/utils/CnpjUtils";
import { CNPJ_ALPHANUMERIC_MASK, cnpjUppercasePipe } from "../../shared/utils/cnpjMask";
import { getAccountData } from "../../Functions/account-data/get-account-data";


class PedidoAtacadoEtapaUm extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    this._ultimoCnpjConsultado = "";

    PedidoAtacadoEtapaUm.contextType = AppContext;
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.props.onChange({ [event.target.name]: event.target.value });
  }

  buscarNomeOtica = async cnpj => {
    const cnpjLimpo = CnpjUtils.cleanCnpj(cnpj || "");
    if (cnpjLimpo.length !== 14) return;
    if (this._ultimoCnpjConsultado === cnpjLimpo) return;
    this._ultimoCnpjConsultado = cnpjLimpo;
    try {
      const data = await getAccountData(cnpjLimpo);
      if (this._ultimoCnpjConsultado !== cnpjLimpo) return;
      if (data?.nome) {
        this.props.onChange({
          otica: { ...this.props.otica, nome: data.nome, cnpj: CnpjUtils.formatCnpj(cnpjLimpo) },
          empresaFaturamento: data.nome,
          dados_empresa_faturamento: data.nome,
        });
      }
    } catch (e) {
      // mantém empresaFaturamento vazio em caso de falha
    }
  };

  handleChangeEmpresa = evt => {
    const { name, value, type } = evt.target;
    let selectedText;
    if (type === "select-one") {
      const selectedIndex = evt.target.selectedIndex;
      selectedText = evt.target?.options?.[selectedIndex]?.text || value;
    } else if (type === "text" || type === "input") {
      selectedText = value;
    }

    if (name === "dados_empresa_faturamento_cnpj" && selectedText) {
      const cnpjWithoutMask = CnpjUtils.cleanCnpj(value);
      if (type === "select-one") {
        this.props.onChange({
          otica: { nome: selectedText, cnpj: value, redeOticas: true },
          empresaFaturamento: selectedText,
          dados_empresa_faturamento: selectedText,
          dados_empresa_faturamento_cnpj: cnpjWithoutMask,
        });
      } else {
        this.props.onChange({
          otica: { ...this.props.otica, cnpj: value, nome: "" },
          empresaFaturamento: "",
          dados_empresa_faturamento: "",
          dados_empresa_faturamento_cnpj: cnpjWithoutMask,
        });
        this.buscarNomeOtica(cnpjWithoutMask);
      }
    }
  };

  handleChangeLapa = evt => {
    const { value } = evt.target;
    const cnpjLimpo = CnpjUtils.cleanCnpj(value);
    const inputEl = document.getElementById("dados_empresa_faturamento_cnpj");
    if (inputEl) inputEl.style.boxShadow = "0 0 0 1px #B5B5B5";
    this.props.onChange({
      otica: { ...this.props.otica, cnpj: value, nome: "" },
      empresaFaturamento: "",
      dados_empresa_faturamento: "",
      dados_empresa_faturamento_cnpj: cnpjLimpo,
      rastreabilidade: { ...this.props.rastreabilidade, fieldError: false },
    });
    this.buscarNomeOtica(cnpjLimpo);
  };

  render() {
    const { otica, disableFields, redes = null, dados_empresa_faturamento_cnpj, redeOticas, rastreabilidade } = this.props;
    let contextAux = this.context;
    const isLapa = this.context.userSession.modulos.includes("Pedido e Simulação Laboratórios");

    return (
      <>
        <p className="titulo-sessao">
          <Badge fill className="me-2">
            1
          </Badge>
          Insira os dados do pedido e solicitante
        </p>
        <div className="row mb-5">
          <div className="col-12 col-md-4">
            <Input
              name="numeroPedido"
              type="text"
              label="Nº do pedido da ótica*"
              aria="Preencha nº do pedido"
              width="100%"
              autocomplete="off"
              disabled={disableFields}
              readOnly={disableFields}
              onChange={this.handleChange}
              value={this.props.numeroPedido}
            />
          </div>
          <div className="col-12 col-md-8">
            {this.context.userSession.modulos.includes("Consulta Cupom") ? (
              <>
                <Input
                  name="dados_empresa_faturamento_cnpj"
                  type="text"
                  label="Empresa de faturamento*"
                  width="100%"
                  aria="Preencha a Empresa de faturamento"
                  value={CnpjUtils.formatCnpj(otica.cnpj || "") || ""}
                  onChange={this.handleChangeEmpresa}
                  max="18"
                  mask={CNPJ_ALPHANUMERIC_MASK}
                  pipe={cnpjUppercasePipe}
                />
              </>
            ) : isLapa ? (
              <>
                <Input
                  name="dados_empresa_faturamento_cnpj"
                  type="text"
                  label="Empresa de faturamento*"
                  width="100%"
                  aria="Preencha o CNPJ da Empresa de faturamento"
                  value={otica.cnpj || ""}
                  onChange={this.handleChangeLapa}
                  max="18"
                  mask={CNPJ_ALPHANUMERIC_MASK}
                  pipe={cnpjUppercasePipe}
                  disabled={disableFields}
                  readOnly={disableFields}
                />
              </>
            ) : (
              <>
                {(!redeOticas || !contextAux.userSession.redeOticas) && (
                  <Input
                    name="empresaFaturamento"
                    type="text"
                    label="Empresa de faturamento*"
                    width="100%"
                    aria="Preencha a Empresa de faturamento"
                    value={otica.nome || ""}
                    readOnly={true}
                    disabled={disableFields}
                    onChange={this.handleChange}
                  />
                )}
                {redeOticas && contextAux.userSession.redeOticas && (
                  <Select
                    label="Empresa de faturamento*"
                    width="100%"
                    id="selectEmpresaFaturamento"
                    name="dados_empresa_faturamento_cnpj"
                    itens={redes}
                    value={dados_empresa_faturamento_cnpj || ""}
                    onChange={this.handleChangeEmpresa}
                    aria="Selecione a Empresa de faturamento"
                    placeholder="Selecione a Empresa de faturamento"
                    placeholder_dont_display={true}
                    required
                  />
                )}
              </>
            )}
          </div>
          {
            <div className="col-12 col-md-4">
              {this.props.PossuiProgramaFidelidadeProprio_c && (
                <Input
                  type="number"
                  name="codigoParticipante"
                  label="Código do Participante"
                  width="100%"
                  aria="Código do Participante"
                  tooltip="Informe o seu número do programa de fidelidade do laboratório (caso participe)."
                  value={this.props.codigoParticipante}
                  onChange={this.handleChange}
                />
              )}
            </div>
          }
        </div>
      </>
    );
  }
}

export default PedidoAtacadoEtapaUm;
